import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HeaderSliceState } from './HeaderType'

const initialState: HeaderSliceState = {
    search: '',
    burger: false,
    topic: false,
    filter: false,
}

export const HeaderSlice = createSlice({
    name: 'header',
    initialState: initialState,
    reducers: {
        setSearch: (state, action: PayloadAction<string>) => {
            state.search = action.payload
        },
        setBurger: (state, action: PayloadAction<boolean>) => {
            state.burger = action.payload
        },
        setTopic: (state, action: PayloadAction<boolean>) => {
            state.topic = action.payload
        },
        setFilter: (state, action: PayloadAction<boolean>) => {
            state.filter = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setSearch, setBurger, setTopic, setFilter } = HeaderSlice.actions

export default HeaderSlice.reducer